// src/components/page-content-v4/modules/ContentTabs.tsx
import React from 'react';
import { FileText, Search, Settings } from 'lucide-react';

export type TabType = 'content' | 'seo' | 'settings';

interface Tab {
  id: TabType;
  label: string;
  icon: React.ReactNode;
}

interface ContentTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  isSeoEnabled?: boolean;
}

const ContentTabs: React.FC<ContentTabsProps> = ({
  activeTab,
  onTabChange,
  isSeoEnabled = true,
}) => {
  const tabs: Tab[] = [
    { id: 'content', label: 'Content', icon: <FileText className="h-4 w-4" /> },
    ...(isSeoEnabled ? [{ id: 'seo' as TabType, label: 'SEO', icon: <Search className="h-4 w-4" /> }] : []),
    { id: 'settings', label: 'Settings', icon: <Settings className="h-4 w-4" /> },
  ];

  return (
    <div className="bg-white border border-gray-100 rounded-xl shadow-sm">
      <nav className="flex border-b border-gray-100" aria-label="Tabs">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              flex-1 inline-flex items-center justify-center gap-2 px-4 py-3.5 text-sm font-medium transition-all
              ${index !== tabs.length - 1 ? 'border-r border-gray-100' : ''}
              ${
                activeTab === tab.id
                  ? 'text-primary-600 bg-primary-50/60'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50/50'
              }
            `}
            aria-current={activeTab === tab.id ? 'page' : undefined}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default ContentTabs;
